import { GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';

const TruckTypeTableHeaderData = (): GridColDef[] => {
  const { t } = useTranslation(['RoutesCalculationWidget']);

  return [
    {
      field: 'default_name',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.TruckType'),
      width: 200,
      sortable: true,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-left',
    },
    {
      field: 'height',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.Height'),
      type: 'number',
      sortable: true,
      flex: 2,
      minWidth: 130,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-center',
    },
    {
      field: 'length',
      type: 'number',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.Length'),
      sortable: true,
      flex: 1,
      minWidth: 130,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-center',
    },
    {
      field: 'width',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.Width'),
      type: 'number',
      sortable: true,
      flex: 2,
      minWidth: 130,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-center',
    },
    {
      field: 'ldm',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.MaxLDM'),
      type: 'string',
      sortable: true,
      flex: 1,
      minWidth: 130,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-center',
    },
    {
      field: 'max_volume',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.MaxCargoVolume'),
      type: 'string',
      sortable: true,
      flex: 1,
      minWidth: 130,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-center',
    },
    {
      field: 'max_weight',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.MaxCargoWeight'),
      flex: 2,
      sortable: true,
      minWidth: 130,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-center',
    },
    {
      field: 'count_pallets',
      headerName: t('RoutesCalculationWidget:TruckTypeInformation.Pallets'),
      flex: 2,
      sortable: true,
      minWidth: 220,
      headerAlign: 'center',
      cellClassName: 'default-table-container__text-center default-table-container__last-cell',
    },
  ];
};

export default TruckTypeTableHeaderData;
